

export class FilterConfiguration {

  constructor(public inputPlaceHolder: string,
    public searchButtonText: string,
    public clearButtonText,
    public searchTypeLabelText: string,
    public filterTypes: string[]) {
  }

}
